.meter {
  position: relative;
}

.meter--horizontal {
  flex-direction: row;
  height: 6px;
  width: 100%;
}

.meter--vertical {
  flex-direction: column;
  height: 100%;
  width: 6px;
}

.meter--primary {
  background-color: var(--tuna-palette-primary-light);
}

.meter--secondary {
  background-color: var(--tuna-palette-secondary-light);
}
